module.exports = __webpack_public_path__ + "static/img/newCode2.329acf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newCode2.png
// module id = ajb5
// module chunks = 0